import styled from 'styled-components';
import { hpxTokens } from '../components/ThemeProvider';
import tokens from '@veneer/tokens';

export const PSAPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100dvh; /* Dynamic viewport height for  modern browsers */
  height: 100vh; /* Fallback for browsers that don't support dvh */
  background-color: ${hpxTokens.manatee3};
  margin: 0;
  display: grid;
  place-items: center;
  direction: ${(props) => (props.isRTL ? 'rtl' : 'ltr')};

  a {
    color: ${tokens.color.royalBlue7} !important;
    &:hover {
        color: ${tokens.color.royalBlue8} !important;
    }
  }

  //fallback for 575px screens
  @media screen and (min-width: 574px) and (max-width: ${tokens.layout.smMin}) {
    font-family: "Forma DJR UI", Arial, sans-serif;

    h3 {
    font-size: 32px !important; 
    font-weight: 400;
    line-height: 40px;
    }

    h5 {
      font-size: 20px !important;
      font-weight: 400;
      line-height: 28px;
    }

    p {
      font-size: 14px !important;
      font-weight: 400;
      line-height: 24px !important;
    }
  }
`;

export const PSAPageContainer = styled.div`
  width: 100%;
  max-width: 740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${tokens.layout.size6};

  @media screen and (max-width: ${tokens.layout.xsMax}) {
    gap: ${tokens.layout.size4};
    padding: 0 ${tokens.layout.size2};
  }

  @media screen and (min-width: ${tokens.layout.xsMax}) and (max-width: ${tokens.layout.mdMax}) {
    gap: ${tokens.layout.size4};
    padding: 0 ${tokens.layout.size4};
  }
`;

export const PSATitle = styled.h3``;

export const PSACardContent = styled.div`
  padding: ${tokens.layout.size6};
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size6};

  @media screen and (max-width: ${tokens.layout.xsMax}) {
    gap: ${tokens.layout.size4};
    padding: ${tokens.layout.size4};
  }

  @media screen and (min-width: ${tokens.layout.smMin}) and (max-width: ${tokens.layout.mdMax}) {
    gap: ${tokens.layout.size5};
    padding: ${tokens.layout.size5};
  }
`;

export const PSABodyText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.layout.size6};

  a {
    text-decoration: underline;
  }

  @media screen and (max-width: ${tokens.layout.xsMax}) {
    gap: ${tokens.layout.size4};
  }

  @media screen and (min-width: ${tokens.layout.smMin}) and (max-width: ${tokens.layout.mdMax}) {
    gap: ${tokens.layout.size5};
  }
`;

export const PSAButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${tokens.layout.size4};

    button {
    border-radius: 100vh;
    color: ${tokens.color.royalBlue7};
    border-color: ${tokens.color.royalBlue7};
    padding: 14px ${tokens.layout.size5};
    min-width: 85px;
    min-height: 48px;

    > span {
      line-height: ${tokens.layout.size5};
    }

    :hover, :active {
      background-color: ${tokens.color.royalBlue2};
      border-color: ${tokens.color.royalBlue7};      
      color: ${tokens.color.royalBlue7};
    }

  }
`;